import { render, staticRenderFns } from "./List.vue?vue&type=template&id=fecdbf14&scoped=true&v-if=list%20%26%26%20list.length%20%3E%200&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=fecdbf14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecdbf14",
  null
  
)

export default component.exports